// Third-party Imports
import { configureStore } from '@reduxjs/toolkit'

// Slice Imports
import avatarReducer from '@/redux-store/slices/avatar'
import languageReducer from '@/redux-store/slices/language'

export const store = configureStore({
  reducer: {
    avatarReducer,
    languageReducer
  },
  middleware: getDefaultMiddleware => getDefaultMiddleware({ serializableCheck: false })
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
